export const EXTERNAL_REGISTER_ROUTE_SEGMENTS = {
  root: "external-register",
  import: "import",
  importHistory: "import-history",
  admin: "admin",
  legacyImport: "external-register-import",
  legacyImportHistory: "external-register-import/history",
} as const;

export const EXTERNAL_REGISTER_RELATIVE_ROUTES = {
  root: EXTERNAL_REGISTER_ROUTE_SEGMENTS.root,
  import: `${EXTERNAL_REGISTER_ROUTE_SEGMENTS.root}/${EXTERNAL_REGISTER_ROUTE_SEGMENTS.import}`,
  importHistory: `${EXTERNAL_REGISTER_ROUTE_SEGMENTS.root}/${EXTERNAL_REGISTER_ROUTE_SEGMENTS.importHistory}`,
  admin: `${EXTERNAL_REGISTER_ROUTE_SEGMENTS.root}/${EXTERNAL_REGISTER_ROUTE_SEGMENTS.admin}`,
} as const;

const settingsPath = (path: string) => `/settings/${path}`;

export const EXTERNAL_REGISTER_SETTINGS_ROUTES = {
  root: settingsPath(EXTERNAL_REGISTER_RELATIVE_ROUTES.root),
  import: settingsPath(EXTERNAL_REGISTER_RELATIVE_ROUTES.import),
  importHistory: settingsPath(EXTERNAL_REGISTER_RELATIVE_ROUTES.importHistory),
  admin: settingsPath(EXTERNAL_REGISTER_RELATIVE_ROUTES.admin),
} as const;

export type ExternalRegisterRouteKey = keyof typeof EXTERNAL_REGISTER_RELATIVE_ROUTES;

export type ExternalRegisterRouteMetadata = {
  key: ExternalRegisterRouteKey;
  labelKey: string;
  relativePath: typeof EXTERNAL_REGISTER_RELATIVE_ROUTES[ExternalRegisterRouteKey];
  settingsPath: typeof EXTERNAL_REGISTER_SETTINGS_ROUTES[ExternalRegisterRouteKey];
  nestedInSettingsNav: boolean;
  landingDescriptionKey?: string;
  statusKey?: string;
};

export const EXTERNAL_REGISTER_ROUTE_METADATA: Record<ExternalRegisterRouteKey, ExternalRegisterRouteMetadata> = {
  root: {
    key: "root",
    labelKey: "externalRegister.routes.root",
    relativePath: EXTERNAL_REGISTER_RELATIVE_ROUTES.root,
    settingsPath: EXTERNAL_REGISTER_SETTINGS_ROUTES.root,
    nestedInSettingsNav: false,
  },
  import: {
    key: "import",
    labelKey: "externalRegister.routes.import",
    relativePath: EXTERNAL_REGISTER_RELATIVE_ROUTES.import,
    settingsPath: EXTERNAL_REGISTER_SETTINGS_ROUTES.import,
    nestedInSettingsNav: true,
    landingDescriptionKey: "externalRegister.landing.destinations.import.description",
    statusKey: "externalRegister.landing.destinations.import.status",
  },
  importHistory: {
    key: "importHistory",
    labelKey: "externalRegister.routes.importHistory",
    relativePath: EXTERNAL_REGISTER_RELATIVE_ROUTES.importHistory,
    settingsPath: EXTERNAL_REGISTER_SETTINGS_ROUTES.importHistory,
    nestedInSettingsNav: true,
    landingDescriptionKey: "externalRegister.landing.destinations.importHistory.description",
    statusKey: "externalRegister.landing.destinations.importHistory.status",
  },
  admin: {
    key: "admin",
    labelKey: "externalRegister.routes.admin",
    relativePath: EXTERNAL_REGISTER_RELATIVE_ROUTES.admin,
    settingsPath: EXTERNAL_REGISTER_SETTINGS_ROUTES.admin,
    nestedInSettingsNav: true,
    landingDescriptionKey: "externalRegister.landing.destinations.admin.description",
    statusKey: "externalRegister.landing.destinations.admin.status",
  },
};

export const EXTERNAL_REGISTER_SETTINGS_NAV_ITEMS = [
  EXTERNAL_REGISTER_ROUTE_METADATA.root,
  EXTERNAL_REGISTER_ROUTE_METADATA.import,
  EXTERNAL_REGISTER_ROUTE_METADATA.importHistory,
  EXTERNAL_REGISTER_ROUTE_METADATA.admin,
] as const;

export const EXTERNAL_REGISTER_LANDING_DESTINATIONS = [
  EXTERNAL_REGISTER_ROUTE_METADATA.import,
  EXTERNAL_REGISTER_ROUTE_METADATA.importHistory,
  EXTERNAL_REGISTER_ROUTE_METADATA.admin,
] as const;

export const isExternalRegisterImportFlowPath = (pathname: string) => (
  pathname === EXTERNAL_REGISTER_SETTINGS_ROUTES.import
  || pathname === EXTERNAL_REGISTER_SETTINGS_ROUTES.importHistory
);
